import {CognitoUserPool} from 'amazon-cognito-identity-js';
const poolData={
    // UserPoolId:'ap-south-1_KWzOP95oP',
    // ClientId:'44tfbor6f2immslp7ihivfmuo'
    UserPoolId:'ap-south-1_Y7RVvkpQe',
    ClientId:'6q1i98701mm499t3d0f833s00m'
  }
  export default new CognitoUserPool(poolData); 